export const trackAccountMenuView = subscriptionStatusText => {
  return window?.hepsiBus?.track('ComponentView', {
    page_type: 'account',
    component: 'Premium touchpoint',
    page_value: subscriptionStatusText || 'NonLogin'
  });
};

export const trackAccountMenuClicked = subscriptionStatusText => {
  return window?.hepsiBus?.track('LinkClick', {
    page_type: 'account',
    placement: 'button',
    location: 'Premium touchpoint',
    page_value: subscriptionStatusText || 'NonLogin'
  });
};
